import {
    apiRequest,
    CuttingCategoryCreate,
} from "../../../../../services/adapters/master/cuttingCategoryService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", CuttingCategoryCreate, {
            body: query
        }, true)
    }
    // fetchCheck = async (query) => {
    //     return await apiRequest("post", HollydayCheckdate, {
    //         body: query
    //     }, true)
    // }

}

export default CreateRepository